import React from "react";
import { Link } from "react-router-dom";
import "./MostLovedBanner.css";
import mostLovedBanner from "../../assets/most-loved-banner.webp";

const MostLovedBanner = () => {
  return (
    <section className="most-loved-section">
      {/* Make whole banner clickable */}
      <Link to="/category/dresses" className="most-loved-link">
        {mostLovedBanner && (
          <img 
            src={mostLovedBanner}
            alt="Our Most-Loved Pieces - Shop Now"
            className="most-loved-image"
            loading="lazy"
          />
        )}
      </Link>
    </section>
  );
};

export default MostLovedBanner;